import { useContext, useEffect, useState } from "react";
import { AppBar, Avatar, Button, ButtonProps, IconButton, styled, Toolbar, Tooltip } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import { Box } from "@mui/system";
import DropMenu from "./DropMenu";
import { AppContext } from "../../scripts/context/App";
import { connectWallet } from "../../layouts/smart-contracts";
import { getShortenAddress } from "../../scripts/constants";
import Jazzicon, { jsNumberForAddress } from "react-jazzicon";

const drawerWidth = 240;

const CustomButton = styled(Button)<ButtonProps>(() => ({
  color: "#10269C",
  backgroundColor: "#00FFFF",
  boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
  borderRadius: "8px",
  minWidth: "150px",
  textTransform: "unset",
  '&:hover': {
    color: "#fff",
    backgroundColor: "#10269C",
  },
}));

export default function CustomAppBar(
  { handleDrawerToggle }: { handleDrawerToggle: () => void }
) {
  const { user, connectedAddress, setState } = useContext(AppContext);
  const [anchorElUser, setAnchorElUser] = useState(false);
  const handleOpenUserMenu = (event: any) => setAnchorElUser(event.currentTarget);

  return (
    <AppBar
      position="fixed"
      sx={{
        width: { sm: `calc(100% - ${drawerWidth}px)` },
        ml: { sm: `${drawerWidth}px` },
      }}
    >
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: {
            xs: 'space-between',
            sm: 'flex-end',
            md: 'flex-end',
          },
        }}
      >
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { sm: 'none' } }}
        >
          <MenuIcon />
        </IconButton>
        <Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2}}>
            <CustomButton onClick={() => connectedAddress ? {} : connectWallet(setState)}>
              {connectedAddress ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Jazzicon diameter={20} seed={jsNumberForAddress(connectedAddress)} />
                  {getShortenAddress(connectedAddress)}
                </Box>
              ) : "Connect"}
            </CustomButton>
            <Tooltip onClick={handleOpenUserMenu} title="Manager Area">
              <IconButton sx={{ p: 0 }}>
                <Avatar
                  alt={user.full_name}
                  src={user.avatar}
                />
              </IconButton>
            </Tooltip>
          </Box>
          <DropMenu
            anchorElUser={anchorElUser}
            setAnchorElUser={setAnchorElUser}
          />
        </Box>
      </Toolbar>
    </AppBar>
  )
}